import columns from '../../../../react-table/helpers/columns';
import { sumTotal, totalRowRatio } from '../../../../react-table/helpers/rowTotals';
import ReportDefinitions from '../../../../common/config/ReportDefinitions';

let replacedDate;
export function getNavigationOptions(rowInfo) {
  if (rowInfo.original) {
    const date = rowInfo.original.postalScanDate;
    replacedDate = date.toString().replace('/', ' ');
  }
  const currentDatetime = new Date(replacedDate);
  const formattedDate = `${currentDatetime.getFullYear()}-${currentDatetime.getMonth() + 1}-${currentDatetime.getDate()}`;
  return rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.MRD_XML_ANALYSIS.id,
    mainReportId: ReportDefinitions.MRD_XML_DAILY_ANALYSIS.id,
    requestParams: {
      date: true,
      destinationExchangeOffices: [],
      direction: ReportDefinitions.MRD_XML_ANALYSIS.reportDirections[0],
      period: {
        from: formattedDate,
        to: formattedDate,
      },
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {};
}

export default (data) => {
  const {
    DateColumn,
    NumberColumn,
    PercentageColumn,
    NavigationColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new DateColumn('Date', 'postalScanDate').withTotalHeader('Total'),
        new NumberColumn('Denested', 'denested').withTotalHeader(sumTotal),
        new NumberColumn('Missed', 'missed').withTotalHeader(sumTotal),
        new NavigationColumn(new NumberColumn('Total', 'total').withTotalHeader(sumTotal), getNavigationOptions),
        new PercentageColumn('% Denested', 'pctDenested').withTotalHeader(totalRowRatio(['denested', 'total'])),
        new NumberColumn('Sum Attr Overall', 'sumAttrOverall').withShow(false),
        new NumberColumn('Sum Total Overall', 'sumTotalOverall').withShow(false),
        new PercentageColumn('% Denested overall', 'pctDenestedOverall').withTotalHeader(totalRowRatio(['sumAttrOverall', 'sumTotalOverall'])),
        new NumberColumn('MRD labels scanned', 'mrdLabelsScanned').withTotalHeader(sumTotal),
        new NumberColumn('MRD labels w/o denesting', 'mrdLabelsDenesting').withTotalHeader(sumTotal),
        new NumberColumn('Nests', 'nests').withTotalHeader(sumTotal),
      ],
    },
  ];
};
